import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import {
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
} from "@pimo/pimo-components/src/lib/pm-components";

import { TestAppState } from "../../../app";
import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../../utils/get-plural-of-item-name";
import {
  getPluralOfProjectName,
  getProjectName,
} from "../../../utils/get-plural-of-project-name";
import { getOverviewCardCopy } from "../get-card-copy";

export function addDueItemsAndProjectsCards(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
): void {
  const {
    itemName,
    itemNamePlural,
    projectName,
    projectNamePlural,
    getCardCopy,
  } = getOverviewCardCopy(app);

  const numberOfItemsDueComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfItemsDueComponent",
      title: "",
      description: "",
      labels: ["#ofItemsDue"],
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfItemsDueComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "numberOfItemsDueComponent",
      labels: ["#ofItemsDue"],
      description: getCardCopy(language, "dueItems").description,
      title: getCardCopy(language, "dueItems").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  numberOfItemsDueComponent.mapState(({ dashboard, settings, language }) => {
    return {
      title: getLocalizedCardCopy(language, "dueItems", {
        itemName: getItemName(settings?.configuration?.itemName, language),
        itemNamePlural: getPluralOfItemName(
          settings?.configuration?.itemName,
          language
        ),
        projectName,
        projectNamePlural,
      }).title,
      number: dashboard?._calculated?.numberOfOverdueSubEntities ?? 0,
    };
  });

  const numberOfProjectsDueComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfProjectsDueComponent",
      title: "",
      description: "",
      labels: ["#ofProjectsDue"],
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfProjectsDueComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "numberOfProjectsDueComponent",
      labels: ["#ofProjectsDue"],
      description: getCardCopy(language, "dueProjects").description,
      title: getCardCopy(language, "dueProjects").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  numberOfProjectsDueComponent.mapState(({ dashboard, settings, language }) => {
    return {
      title: getLocalizedCardCopy(language, "dueProjects", {
        itemName,
        itemNamePlural,
        projectName: getProjectName(
          settings?.configuration?.projectName,
          language
        ),
        projectNamePlural: getPluralOfProjectName(
          settings?.configuration?.projectName,
          language
        ),
      }).title,
      number: dashboard?._calculated?.numberOfOverdueProjects ?? 0,
    };
  });
}
